import styled from "styled-components/macro"

export const S_MobileOnly = styled.div`
  @media only screen and (min-width: 1260px) {
    display: none;
  }
`

export const S_DesktopOnly = styled.div`
  @media only screen and (max-width: 1259px) {
    display: none;
  }
`
